import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { marked } from "marked";

function stripContent(content = "") {
  return content
    .replace(/<[^>]*>/g, " ")
    .replace(/[#*_`>\-[\]()]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function getReadingTime(post) {
  const words = stripContent(post.content).split(" ").filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 225));
}

export function PostDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`/posts.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        const foundPost = data.find((p) => p.id === parseInt(id));
        setPost(foundPost);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  if (loading) {
    return (
      <div className="editorial-state">
        <div className="editorial-state__inner">
          <p className="editorial-state__message">Loading post...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="editorial-state">
        <div className="editorial-state__inner">
          <p className="editorial-state__message">Error: {error}</p>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="editorial-state">
        <div className="editorial-state__inner">
          <div className="editorial-state__message">
            <p>Post not found</p>
            <Link to="/blog">Back to Writing</Link>
          </div>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    if (post.format === "markdown") {
      return (
        <div
          className="blog-article"
          dangerouslySetInnerHTML={{ __html: marked(post.content) }}
        />
      );
    } else {
      return (
        <div
          className="blog-article"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      );
    }
  };

  return (
    <div className="article-page">
      <div className="article-page__inner">
        <Link to="/blog" className="article-back">
          <span aria-hidden="true">←</span>&nbsp; Back to writing
        </Link>

        <article>
          <header className="article-header">
            <p className="article-header__meta">
              {getReadingTime(post)} min read
            </p>
            <h1>{post.title}</h1>
          </header>

          {renderContent()}
        </article>
      </div>
    </div>
  );
}
